import {MantineProvider} from '@mantine/core'
import {ComponentProps, useId} from 'react'
import {IconContext} from 'react-icons'

const ColorSchemedChildren = ({children, colorScheme}: ComponentProps<'div'> & {colorScheme: 'light' | 'dark'}) => {
  const id = useId().replace(/:/g, '')
  const selector = `#${id}`
  return (
    <div id={id}>
      <MantineProvider
        getRootElement={() => document.querySelector<HTMLElement>(selector)!}
        cssVariablesSelector={selector}
        forceColorScheme={colorScheme}>
        {children}
      </MantineProvider>
    </div>
  )
}

export const DarkSchemedChildren = ({children, ...props}: ComponentProps<'div'>) => (
  <ColorSchemedChildren colorScheme='dark'>
    <IconContext.Provider value={{color: 'color-mix(in srgb, var(--mantine-color-text), transparent 40%)'}}>
      {children}
    </IconContext.Provider>
  </ColorSchemedChildren>
)

export const LightSchemedChildren = ({children}: {children: React.ReactNode}) => (
  <ColorSchemedChildren colorScheme='light'>{children}</ColorSchemedChildren>
)
